import http from "../../../utils/HttpUtils";

//货架接口服务
class ShelveService {
    //新建货架
    static async insert(data) {
        const apiUrl = "/base/warehouse/shelves/insert";
        return await http.post(apiUrl, data);
    }

    //修改货架
    static async update(data) {
        const apiUrl = "/base/warehouse/shelves/update";
        return await http.post(apiUrl, data);
    }

    //根据ID查询货架信息
    static async findOne(id) {
        const apiUrl = `/whShelves/find/${id}`;
        return await http.get(apiUrl);
    }

    //分页查询货架信息
    static async findPage(data) {
        const apiUrl = "/base/warehouse/shelves/findPage";
        return await http.post(apiUrl, data);
    }

    //根据ID删除货架信息
    static async deleteOne(id) {
        const apiUrl = `/whShelves/deleteOne/${id}`;
        return await http.post(apiUrl);
    }
}

export default ShelveService;
